/**
 * Apollo Client 환경 설정
 *
 * API 호스트, 프로토콜, Quote 서버 설정 등 환경 변수 관리
 */

// 환경 판별
export const isDevelopment = process.env.NODE_ENV === "development";

// API 호스트 정의 (런타임 환경 변수 > 빌드타임 환경 변수 > 기본값)
export const apiHost =
  window.__RUNTIME_ENV__?.VITE_API_HOST ||
  import.meta.env.VITE_API_HOST ||
  (isDevelopment ? "localhost:3000" : "fkdnaapi.raoom.net");

// Quote 서버 호스트 정의 (시세 데이터 전용)
export const quoteHost =
  window.__RUNTIME_ENV__?.VITE_QUOTE_HOST ||
  import.meta.env.VITE_QUOTE_HOST ||
  (isDevelopment ? "localhost:4000" : "quote.raoom.net");

// 프로토콜 선택
export const httpProtocol = isDevelopment ? "http" : "https";
export const wsProtocol = isDevelopment ? "ws" : "wss";

// 엔드포인트 URL
export const ENDPOINTS = {
  graphql: `${httpProtocol}://${apiHost}/graphql`,
  subscriptions: `${wsProtocol}://${apiHost}/subscriptions`,
  quoteGraphql: `${wsProtocol}://${quoteHost}/graphql`,
};

// 시세 구독 이름 목록 (quoteServer로 라우팅)
export const QUOTE_SUBSCRIPTION_NAMES = ['subscribeReal', 'subscribeRealSign'];
